import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import { Box, Tooltip } from '@mui/material';
import { FILTER_COUNT_BADGE_SX } from 'components/common/dataGrid/styles';
import { ButtonIcon } from 'components/general';
import { formatTranslation } from 'intl';
import { FiltersTranslationKeys } from 'intl/keys';
import { ReactElement, MouseEvent, useRef } from 'react';
import { useIntl } from 'react-intl';
import { Color } from 'shared/utils/colors';

export type FiltersIndicatorButtonProps = Readonly<{
  activeFiltersCount: number;
  disabled?: boolean;
  title?: string;
  isOpen: () => boolean;
  onToggle: (wasOpenAtInteraction?: boolean) => void;
}>;

export function FiltersIndicatorButton({
  activeFiltersCount,
  disabled = false,
  title,
  isOpen,
  onToggle,
}: FiltersIndicatorButtonProps): ReactElement {
  const intl = useIntl();
  const wasOpenAtInteractionRef = useRef<boolean | undefined>(undefined);
  const resolvedTitle =
    title ?? formatTranslation(intl, FiltersTranslationKeys.actionFilter);

  const handleMouseDownCapture = (event: MouseEvent): void => {
    if (disabled) {
      return;
    }

    event.stopPropagation();
    wasOpenAtInteractionRef.current = isOpen();
  };

  const handleClick = (event: MouseEvent): void => {
    event.preventDefault();
    event.stopPropagation();
    if (disabled) {
      return;
    }

    onToggle(wasOpenAtInteractionRef.current);
    wasOpenAtInteractionRef.current = undefined;
  };

  return (
    <Tooltip key="filters_action_filter" title={resolvedTitle}>
      <ButtonIcon
        disabled={disabled}
        onMouseDownCapture={handleMouseDownCapture}
        onClick={handleClick}
      >
        <TuneRoundedIcon sx={{ color: Color.black }} />
        {activeFiltersCount > 0 ? (
          <Box sx={FILTER_COUNT_BADGE_SX}>{activeFiltersCount}</Box>
        ) : null}
      </ButtonIcon>
    </Tooltip>
  );
}
